// extracted by mini-css-extract-plugin
export var img = "img-module--img--rvdgX";
export var jsAnimInit = "img-module--jsAnimInit--38BRL";